$(function () {
  $(".feedback-carosel").each(function (index, el) {
    $(el).slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 683,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
    function syncCustomArrows() {
      setTimeout(function () {
        if ($(el).find(".slick-prev.slick-arrow").hasClass("slick-disabled")) {
          $(el)
            .next(".slick-custom-arrow-container")
            .find(".custom-slick-button-left")
            .removeClass("active");
        } else {
          $(el)
            .next(".slick-custom-arrow-container")
            .find(".custom-slick-button-left")
            .addClass("active");
        }
        if ($(el).find(".slick-next.slick-arrow").hasClass("slick-disabled")) {
          $(el)
            .next(".slick-custom-arrow-container")
            .find(".custom-slick-button-right")
            .removeClass("active");
        } else {
          $(el)
            .next(".slick-custom-arrow-container")
            .find(".custom-slick-button-right")
            .addClass("active");
        }
      }, 200);
    }
    $(el)
      .next(".slick-custom-arrow-container")
      .find(".custom-slick-button-left")
      .on("click", function () {
        $(el).find(".slick-prev.slick-arrow").trigger("click");
        syncCustomArrows();
      });
    $(el)
      .next(".slick-custom-arrow-container")
      .find(".custom-slick-button-right")
      .on("click", function () {
        $(el).find(".slick-next.slick-arrow").trigger("click");
        syncCustomArrows();
      });
    $(el)
      .find("ul.slick-dots button")
      .on("click", function () {
        syncCustomArrows();
      });
    $(el)
      .find("#feedback-carosel")
      .on("swipe", function () {
        syncCustomArrows();
      });
    $(window).on("resize", function () {
      syncCustomArrows();
    });
  });
});
